import React, { useEffect, lazy, Suspense } from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LogoCarousel from "./components/LogoCarousel";
import IntroSection from "./components/IntroSection";
import ExpertsSection from "./components/ExpertsSection";
import ProcessTimeline from "./components/ProcessTimeline";
import FeaturesSection from "./components/FeaturesSection";
import PricingSection from "./components/PricingSection";
import CreditSection from "./components/CreditSection";
import AboutSection from "./components/AboutSection";
import CTASection from "./components/CTASection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import StickyCTA from "./components/StickyCTA";
import AdminProtected from "./components/AdminProtected";

const Jobs = lazy(() => import("./pages/Jobs"));
const JobDetail = lazy(() => import("./pages/JobDetail"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminJobs = lazy(() => import("./pages/AdminJobs"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>HIREKA - Die Recruiting Revolution | Kandidaten in 24h</title>
        <link rel="canonical" href="https://hireka.io/" />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <LogoCarousel />
        <IntroSection />
        <ProcessTimeline />
        <ExpertsSection />
        <FeaturesSection />
        <PricingSection />
        <CreditSection />
        <AboutSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <CookieBanner />
      <StickyCTA />
    </>
  );
};

function App() {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-white" />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <AdminProtected>
              <AdminDashboard />
            </AdminProtected>
          } />
          <Route path="/admin/jobs" element={
            <AdminProtected>
              <AdminJobs />
            </AdminProtected>
          } />
        </Routes>
        </Suspense>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
